import React, { Component } from "react";
import { Button, Popconfirm, Space, Upload } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import { withTheme } from "styled-components";
import AppContext from "../../../AppContext";
import { FileAddOutlined, LeftOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

class AvatarUpload extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      deleteConfirm: false,
    };
  }

  resizePhoto = photo => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(photo);
      reader.onload = () => {
        const canvas = document.createElement("canvas");
        const img = document.createElement("img");
        img.src = reader.result;
        img.onload = () => {
          const ctx = canvas.getContext("2d");
          canvas.width = 100;
          canvas.height = 100;
          ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, 100, 100);
          canvas.toBlob(resolve);
        };
      };
    });
  };

  render() {
    let imageProps = {
      name: "avatar.png",
      className: "avatar-upload",
      showUploadList: true,
      listType: "picture",
      fileList:
        (this.context.user_info?.photo_url ?? "") !== ""
          ? [
              {
                name: this.context.capitalizeStr(this.props.intl.formatMessage({ id: "profile photo" })),
                uid: this.context.user_info?.photo_uuid,
              },
            ]
          : [],
      onRemove: () => this.setState({ deleteConfirm: true }),
      accept: ".png, .jpeg, .jpg",
      disabled: this.props.upload_loading,
      beforeUpload: this.resizePhoto,
      customRequest:
        (this.context.user_info?.photo_url ?? "") === ""
          ? this.props.handleChange
          : e => {
              this.props.removeAvatar(this.context.user_info?.photo_uuid);
              this.props.handleChange(e);
            },
    };
    return (
      <Popconfirm
        title={
          <p className="text-capitalize-first">
            <FormattedMessage id={"are you sure you want to delete"} />?
          </p>
        }
        visible={this.state.deleteConfirm}
        trigger="click"
        onConfirm={() => {
          this.props.onDelete();
          this.setState({ deleteConfirm: false });
        }}
        onCancel={() => this.setState({ deleteConfirm: false })}
        okText={
          <div className="text-capitalize-first">
            <FormattedMessage id="yes" />
          </div>
        }
        cancelText={
          <div className="text-capitalize-first">
            <FormattedMessage id="no" />
          </div>
        }
        placement="bottomRight"
      >
        <div style={{ paddingTop: "26px" }}>
          <Button
            type="link"
            disabled={this.props.upload_loading}
            onClick={() => this.props.handleUploadChange(false)}
            style={{ paddingBottom: "64px", paddingLeft: "0px", marginLeft: "-4px" }}
          >
            <Space style={{ fontSize: "16px" }}>
              <LeftOutlined fill={this.props.theme.color.blue["blue-6"]} />
              <div className="text-capitalize">
                <FormattedMessage id="go back" />
              </div>
            </Space>
          </Button>
          <Dragger {...imageProps}>
            <div>
              <div className="textColorPrimary marginSmallBottom">
                <FileAddOutlined style={{ fontSize: this.props.theme.text.f30 }} />
              </div>
              <div className="fieldValue marginSmallBottom text-capitalize-first">
                <FormattedMessage id="click or drag a file to this area to upload" />
              </div>
              <div className="fieldValueSub marginSmallBottom text-capitalize-first">
                <FormattedMessage id="only .png, .jpg or .jpeg files" />
              </div>
            </div>
          </Dragger>
        </div>
      </Popconfirm>
    );
  }
}

export default withTheme(injectIntl(AvatarUpload));
